import { CurrencyCode } from 'types/currency';

export interface CreatedAccount {
  username: string;
  firstName: string;
  lastName: string;
  accountName: string;
  shift4MerchantId: string;
  groupAccountId: string;
  /** PSP or Group account uuid when creating a Group Account */
  parentAccountUuid: string;
  parentAccountName?: string;
  mainFiatCurrency: CurrencyCode;
}

export enum CreateAccountStep {
  Form = 'form',
  Verify = 'verify',
  Success = 'success',
}
